import { Link } from "react-router-dom";
import { PageLayout } from "@/components/PageLayout";
import { CalculatorCard } from "@/components/CalculatorCard";
import { Wrench, Calculator as CalcIcon, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoLight from "@/assets/logo-light_t.png";
import logoDark from "@/assets/logo-dark_t.png";
import { useTranslation } from "react-i18next";
import { useLanguageAwareSEO } from "@/hooks/useLanguageAwareSEO";
import { breadcrumbSchema } from "@/utils/structuredData";

import { FileText } from "lucide-react";

const tools = [
  {
    title: "LaTeX Document Editor",
    description: "Create lesson plans, assessments, and reports with live preview",
    icon: FileText,
    href: "/tools/latex-editor",
    category: "physics" as const,
  },
  {
    title: "Unit Converter",
    description: "Convert between SI, CGS, and Imperial units",
    icon: Wrench,
    href: "/calculator/unit-converter",
    category: "physics" as const,
  },
  {
    title: "Time Zone Converter",
    description: "Convert time between different time zones",
    icon: CalcIcon,
    href: "/calculator/timezone-converter",
    category: "general" as const,
  },
  {
    title: "Scientific Notation",
    description: "Convert to and from scientific notation",
    icon: CalcIcon,
    href: "/calculator/scientific-notation",
    category: "physics" as const,
  },
  {
    title: "Significant Figures",
    description: "Count and round to significant figures",
    icon: CalcIcon,
    href: "/calculator/significant-figures",
    category: "physics" as const,
  },
  {
    title: "LaTeX Formatter",
    description: "Format mathematical equations in LaTeX",
    icon: CalcIcon,
    href: "/calculator/latex-formatter",
    category: "physics" as const,
  },
];

export default function Tools() {
  const { t } = useTranslation();
  
  useLanguageAwareSEO([
    (lang) => breadcrumbSchema([
      { name: "Home", url: "https://calclab.app" },
      { name: t('categories.pages.tools.title'), url: "https://calclab.app/tools" }
    ], lang)
  ]);
  
  return (
    <PageLayout>
      <div className="max-w-5xl mx-auto">
        <div className="mb-8 text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">{t('categories.pages.tools.title')}</h1>
          <p className="text-muted-foreground">
            {t('categories.pages.tools.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tools.map((tool) => (
            <CalculatorCard key={tool.title} {...tool} />
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
